import { render, staticRenderFns } from "./ModalNotice.vue?vue&type=template&id=3b8036f1&scoped=true"
import script from "./ModalNotice.vue?vue&type=script&lang=js"
export * from "./ModalNotice.vue?vue&type=script&lang=js"
import style0 from "./ModalNotice.vue?vue&type=style&index=0&id=3b8036f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8036f1",
  null
  
)

export default component.exports